module.exports = __webpack_public_path__ + "img/DE06193.6439130f.png";